export default {
    meta: {
        title: '点位评估',
        url: '/standardstore/tasklist',
        urlName: '标准版拓店-拓店任务'
    }
};
